import { weChatrequest } from '@/utils/request'
//新增设备
export function addActuator(data) {
  return weChatrequest({
    url: '/api/v1/actuator/add',
    method: 'post',
    data
  })
}

//编辑设备
export function editActuator(data) {
  return weChatrequest({
    url: '/api/v1/actuator',
    method: 'put',
    data
  })
}

//简单编辑设备（仅修改阀井相关）
export function updateSimpleActuator(data) {
  return weChatrequest({
    url: '/api/v1/actuator/simple',
    method: 'put',
    data
  })
}

//固件升级
export function upgradeActuator(data) {
  return weChatrequest({
    url: 'api/v1/actuator/firmware/upgrade',
    method: 'post',
    data
  })
}

// 列表查询
export function listPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/listPageWithWell',
    method: 'post',
    data
  })
}

// 测试列表
export function listTestPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/test/listPage',
    method: 'post',
    data
  })
}


// 设备删除
export function deleteActuator(ids) {
  return weChatrequest({
    url: `/api/v1/actuator/${ids}`,
    method: 'delete'
  })
}

// 设备详情查询
export function actuatorDetail(actId) {
  return weChatrequest({
    url: `/api/v1/actuatorDetail/${actId}`,
    method: 'get'
  })
}

//执行器数据导出
export function actuatorEport(data) {
  return weChatrequest({
    url: '/api/v1/actuator/export',
    method: 'post',
    data,
    responseType: "blob",
  })
}

//执行器运行数据导出
export function actuatorRuntimeExport(data) {
  return weChatrequest({
    url: '/api/v1/actuator/exportRuntime',
    method: 'post',
    data,
    responseType: "blob",
  })
}

// 运行数据
export function runtimeById(id) {
  return weChatrequest({
    url: `/api/v1/actuator/runtime/${id}`,
    method: 'get'
  })
}

// 操作记录
export function operationRecord(actNum) {
  return weChatrequest({
    url: `/api/v1/actuator/${actNum}/function-records`,
    method: 'get',
  })
}

// 执行器导入
export function importExcel(data) {
  return weChatrequest({
    url: '/api/v1/actuator/importExcel',
    method: 'post',
    data
  })
}
export function actuatorInvoke(data) {
  return weChatrequest({
    silentError: true,
    url: '/api/v1/actuator/invoke',
    method: 'post',
    data
  })
}
// 工单审核
export function updateState(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/updateState',
    method: 'put',
    data
  })
}
// 待办事宜
export function todoListPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/todoListPage',
    method: 'post',
    data
  })
}
// 我的待办
export function myTodoListPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/myTodoListPage',
    method: 'post',
    data
  })
}
// 已办事宜
export function finishedListPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/finishedListPage',
    method: 'post',
    data
  })
}

// 新增工单
export function addAudit(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/add',
    method: 'post',
    data
  })
}

// 执行工单
export function executeById(id) {
  return weChatrequest({
    silentError: true,
    url: `/api/v1/actuator/audit/execute/${id}`,
    method: 'get'
  })
}
// 重新申请
export function updateAudit(data) {
  return weChatrequest({
    url: '/api/v1/actuator/audit/update',
    method: 'PUT',
    data
  })
}

// 历史告警
export function getrHistoryWarning(data) {
  return weChatrequest({
    url: '/api/v1/actuator/alarm/historyPage',
    method: 'post',
    data
  })
}

// 实时告警
export function runtimePage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/alarm/runtimePage',
    method: 'post',
    data
  })
}

// 开始测试
export function startTest(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testTask/start',
    method: 'post',
    data
  })
}

// 停止单个测试
export function finishTestOne(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/cancel/${id}`,
    method: 'put'
  })
}
// 开始单个测试
export function startTestOne(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/${id}/activate`,
    method: 'put'
  })
}
// 停止全部测试
export function finishTest() {
  return weChatrequest({
    url: `/api/v1/actuator/test/finish`,
    method: 'put'
  })
}
// 执行器退出测试
export function exitTest(data) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/exitActuators`,
    method: 'put',
    data
  })
}

// 执行器加入测试
export function joinTest(data) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/joinActuators`,
    method: 'post',
    data
  })
}
// 分页查询测试记录
export function testListPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testTask/listPage',
    method: 'post',
    data
  })
}

// 分页查询测试单元记录
export function testUnitListPage(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testUnit/listPage',
    method: 'post',
    data
  })
}
// 查询测试单元记录不分页接口
export function testUnitListPageAll(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testUnit/list',
    method: 'post',
    data
  })
}
// 测试执行器列表不分页接口
export function listPageAll(data) {
  return weChatrequest({
    url: '/api/v1/actuator/listWithWell',
    method: 'post',
    data
  })
}
// 查询所有待开始的测试任务不分页
export function getTaskPageAll(params) {
  return weChatrequest({
    url: '/api/v1/actuator/testTask/list',
    method: 'get',
    params
  })
}
export function getActTaskPageAll(actId) {
  return weChatrequest({
    url: `/api/v1/actuator/testUnit/records/${actId}`,
    method: 'get',
  })
}

// 调整计划结束时间
export function updatePlanEndTime(id, data) {
  return weChatrequest({
    url: `/api/v1/actuator/test/${id}/planEndTime`,
    method: 'put',
    data
  })
}
// 编辑测试任务
export function updateTestTask(data) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/update`,
    method: 'put',
    data
  })
}
// 实时数据-历史数据
export function indicator(data) {
  return weChatrequest({
    url: '/api/v1/actuator/indicator',
    method: 'post',
    data
  })
}

// 测试导出
export function customerServiceExport(data) {
  return weChatrequest({
    url: '/qw/customer/exportXls/service',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 更新数据
export function fetchActData(data) {
  return weChatrequest({
    silentError: true,
    url: '/api/v1/actuator/fetch',
    method: 'post',
    data
  })
}

// 批量查询字典数据
export function dictList(data) {
  return weChatrequest({
    url: '/api/v1/dict/dictList',
    method: 'post',
    data
  })
}

export function wellList(query) {
  return weChatrequest({
    url: `/api/valve-well/list`,
    method: 'get',
    params: query
  })
}
// 分页查询测试流程
export function testProcessList(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testProcess/listPage',
    method: 'post',
    data
  })
}

// 新增测试流程
export function addTestProcess(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testProcess',
    method: 'post',
    data
  })
}

// 修改测试流程
export function updateTestProcess(data) {
  return weChatrequest({
    url: '/api/v1/actuator/testProcess',
    method: 'put',
    data
  })
}

// 删除测试流程
export function deleteTestProcess(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcess/${id}`,
    method: 'delete'
  })
}

// 查询测试流程详情
export function testProcessDetail(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcess/${id}`,
    method: 'get'
  })
}

// 查询流程明细列表
export function testProcessDetailList(processId) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcess/${processId}/details`,
    method: 'get'
  })
}
// 新增流程明细
export function addTestProcessDetail(processId,data) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcess/${processId}/details`,
    method: 'post',
    data
  })
}
// 修改流程明细
export function updateTestProcessDetail(detailId,data) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcessDetail/${detailId}`,
    method: 'put',
    data
  })
}


// 删除流程明细
export function deleteTestProcessDetail(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testProcessDetail/${id}`,
    method: 'delete'
  })
}

// 获取启用的测试项列表
export function getEnabledTestItems() {
  return weChatrequest({
    url: '/api/v1/actuator/testItem/enabled',
    method: 'get'
  })
}

// 查询已启用的测试流程
export function getEnabledTestProcess() {
  return weChatrequest({
    url: '/api/v1/actuator/testProcess/enabled',
    method: 'get'
  })
}

// 获取测试任务详情
export function getTestTaskInfo(id) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/${id}/testInfo`,
    method: 'get'
  })
}

// 批量执行器出厂
export function batchDeployActuator(data) {
  return weChatrequest({
    url: '/api/v1/actLifecycle/deploy',
    method: 'post',
    data
  })
}

// 批量执行器报废
export function batchScrapActuator(data) {
  return weChatrequest({
    url: '/api/v1/actLifecycle/scrap',
    method: 'post',
    data
  })
}

// 安装执行器到阀井
export function installActuatorToWell(data) {
  return weChatrequest({
    url: '/api/v1/actLifecycle/install',
    method: 'post',
    data
  })
}

// 获取执行器测试记录列表
export function getActuatorTestResults(id, actId) {
  return weChatrequest({
    url: `/api/v1/actuator/testTask/${id}/results/${actId}`,
    method: 'get'
  })
}


// 手动召测、开关阀及校核使用相同的进度结构。
export function getActuatorManualProgress(recordType, recordId) {
  return weChatrequest({
    silentError: true,
    url: `/api/v1/actuator/manual/progress/${encodeURIComponent(recordType)}/${encodeURIComponent(recordId)}`,
    method: 'get'
  })
}

export function calibrateActuator(id) {
  return weChatrequest({
    silentError: true, url: `/api/v1/actuator/calibrate/${id}`, method: 'get' })
}
